<template>
    <div>
        <div class="form-group" >
            <label class="form-label">{{$t('Bareme.etape1.champs.remarques')}}</label>
            <input type="text" class="form-control" maxlength="90" v-model="dossier.remarques[0]"
                   v-tooltip="{content: getTooltip('Bareme.tooltip.titre.remarques','Bareme.tooltip.contenu.remarques'),
                   placement: 'bottom' }" aria-label="Prémière ligne de remarques" />
            <input type="text" class="form-control" maxlength="90" v-model="dossier.remarques[1]"
                   v-tooltip="{content: getTooltip('Bareme.tooltip.titre.remarques','Bareme.tooltip.contenu.remarques'),
                   placement: 'bottom' }" aria-label="Deuxième ligne de remarques"/>
        </div>
    </div>
</template>

<script>
import TooltipUtils from '../../../utils/TooltipUtils';

export default {
  name: 'section-remarques',
  props: ['dossier', 'submitted'],
  mixins: [TooltipUtils],
};
</script>

<style scoped>

</style>
